// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminUsersController from "./admin_users_controller"
application.register("admin-users", AdminUsersController)

import ContractModalController from "./contract_modal_controller"
application.register("contract-modal", ContractModalController)

import DealerSearchController from "./dealer_search_controller"
application.register("dealer-search", DealerSearchController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EmailContentController from "./email_content_controller"
application.register("email-content", EmailContentController)

import ErrorNotificationController from "./error_notification_controller"
application.register("error-notification", ErrorNotificationController)

import FlashMessagesController from "./flash_messages_controller"
application.register("flash-messages", FlashMessagesController)

import Forms__PermissionTogglerController from "./forms/permission_toggler_controller"
application.register("forms--permission-toggler", Forms__PermissionTogglerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PaymentMethodController from "./payment_method_controller"
application.register("payment-method", PaymentMethodController)

import PhotoGalleryController from "./photo_gallery_controller"
application.register("photo-gallery", PhotoGalleryController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PurePerkFormController from "./pure_perk_form_controller"
application.register("pure-perk-form", PurePerkFormController)

import SalesFormController from "./sales_form_controller"
application.register("sales-form", SalesFormController)

import SalesOrderController from "./sales_order_controller"
application.register("sales-order", SalesOrderController)

import SignatureCanvasController from "./signature_canvas_controller"
application.register("signature-canvas", SignatureCanvasController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import SubscriptionPeriodTogglerController from "./subscription_period_toggler_controller"
application.register("subscription-period-toggler", SubscriptionPeriodTogglerController)

import VideoModalController from "./video_modal_controller"
application.register("video-modal", VideoModalController)

import W9FormController from "./w9_form_controller"
application.register("w9-form", W9FormController)

import Pdfs__PreviewFilledFormController from "./pdfs/preview_filled_form_controller"
application.register("pdfs--preview-filled-form", Pdfs__PreviewFilledFormController)
